import camelCase from 'lodash/camelCase';

import { ErrorDuringSignup } from '../errors';

export * from './user';

/**
 * Ensures the passed in `condition` is truthy, making the assumption
 * that it's required for a sign-up action to complete successfully.
 *
 * @throws {ErrorDuringSignup} if `condition` is falsy
 */
export function assertForValidSignUp(condition: unknown): asserts condition {
  if (!condition) {
    throw new ErrorDuringSignup();
  }
}

export const convertObjectKeysToCamelCase = (
  object: Record<string, unknown>,
): Record<string, unknown> =>
  Object.keys(object).reduce(
    (newObject, key) => ({ ...newObject, [camelCase(key)]: object[key] }),
    {},
  );

export const urlToPathname = (url: string): string => {
  try {
    const urlObj = new URL(url);

    return urlObj.pathname;
  } catch {
    return url;
  }
};

export const formatSecondsAsPartialMinutes = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const secondsRemaining = seconds % 60;

  return `${minutes}:${secondsRemaining > 9 ? '' : '0'}${secondsRemaining}`;
};

export const parseValue = (value: string | null) => {
  if (value === null) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
